{
    "ReportIntervalLanguageFifteenMinutes": "15 Minutes",
    "ReportIntervalLanguageThirtyMinutes": "30 Minutes",
    "ReportIntervalLanguageOneHour": "1 Hour",
    "ReportIntervalLanguageTwoHour": "2 Hours",
    "ReportIntervalLanguageTypeMinute": "Minutes",
    "ReportIntervalLanguageTypeHour": "Hour",
    "ReportIntervalLanguageTypeHourPluralised": "Hours",
    "ReportIntervalLanguageInterpolated": "Total Calls By {} {}",
    "ReportIntervalLanguageCallByInterpolated": "Calls By {} {}",
    "ReportIntervalEntityLanguageCallByNoValueInterpolated": "Calls By {} ({})",
    "ReportIntervalEntityLanguageCallByInterpolated": "Calls By {} {} ({})",
    "ReportIntervalLanguageCallByNoValueInterpolated": "Calls By {}",
    "ReportIntervalTypeMinutes": "Minutes",
    "ReportIntervalTypeHours": "Hours",
    "ReportIntervalTypeDay": "Day",
    "ReportIntervalTypeWeek": "Week",
    "ReportIntervalTypeMonth": "Month",
    "ReportIntervalTypeDayOfTheWeek": "Day Of The Week",
    "ReportIntervalEntityTypeDevicesExtensionsAA": "Devices (Extensions/AA)",
    "ReportIntervalEntityTypeAgents": "Agents",
    "ReportIntervalEntityTypeGroups": "Group/Queues",
    "ReportIntervalEntityTypeDNIS": "DNIS",
    "NAME": "ReportIntervalLanguage"
}